import { useUser } from '../providers/UserProvider';

const Dashboard = () => {
  const { displayName } = useUser();

  return <div>Bienvenido {displayName}</div>;
};

export default Dashboard;
